<template>
  <div class="newsdmbox" v-loading="loading">
    <transition name="slide-fade">
      <top_mobile v-show="topshow"></top_mobile>
    </transition>
    <div style="height: 44px;background: #202334"></div>
    <div class="title">
      <i class="el-icon-arrow-left" style="font-size: 14px;font-weight: bold;" @click="goback()"></i>
      最新资讯
    </div>

    <div class="content" v-if="$route.query.id==0">
      <div class="content1">为“苏州制造赋能”，姑苏区有新动作</div>
      <div class="content2">2021年3月16日</div>
      <div class="content3">
        苏州量子方舟网络科技有限公司CEO肖翱代表母公司苏州大洋供应链集团参与了此次盛会。
      </div>
      <div class="content3">
        2021年的第一个工作日上，苏州市数字经济和数字化发展推进大会以“新年第一会”的昂扬姿态， 凝聚起了全市各个板块用数字赋能高质量发展的磅礴合力，拉开了苏州全力打造“具有世界影响力的国际数字之都”的序幕。
      </div>
      <div class="content4">
        <img src="../../public/statics/img/newlist/3.16/01.png" alt="">
      </div>
      <div class="content3">
        为进一步响应“新年第一会”部署要求，今天，姑苏区人民政府与苏州市工信局联合主办的“服 务苏州智造 赋能产业发展”2021年智能化改造和数字化转型政策宣讲暨供需对接大会召开，主动融入苏州市智能化改造和
        数字化转型大局，助力“苏州制造”品牌的打造。苏州市人民政府副市长沈觅出席并致辞。
      </div>
      <div class="content4">
        <img src="../../public/statics/img/newlist/3.16/02.png" alt="">
      </div>
      <div class="content2-4">
        <div class="content2-4-1">数字化转型</div>
        <div class="content2-4-2">除了向外输出智能化解决方案,</div>
        <div class="content2-4-3">姑苏企业也在发展过程中,</div>
        <div class="content2-4-3">不断寻求自身数字化转型,</div>
        <div class="content2-4-3">下面这家企业就在数字化转型之路上,</div>
        <div class="content2-4-2">取得了不错的成绩！</div>

      </div>

      <div class="content3">
        大洋供应链集团在第三方物流行业深耕20多年，他们利用专业供应链管理技术，链接企业上游 做采购、下游做市场，持续优化供应链管理流程从而实现零库存。
      </div>
      <div class="content4">
        <img src="../../public/statics/img/newlist/3.16/03.png" alt="">
      </div>
      <div class="content3">
        会上，大洋供应链被授牌为市级工业互联网重点平台和专业服务商。
      </div>
      <div class="content3">
        2年多前，大洋供应链开始寻求数字化转型，目前，他们已经将单纯的供应链管理拓展为“平台 +”服务形式，通过产业供应链大数据实现商业SaaS赋能，同时也为其他企业提供诸如仓储智能化改造、供应链金融和供应
        链咨询等服务输出。目前已为多家汽车产业的龙头企业提供供应链一体化增值服务。
      </div>
      <div class="content3">
        大洋供应链集团董事长王勇介绍，供应链数字化是工业互联网的重要组成部分。此次签约项目 将为某电子信息企业打造物流场景的数字化平台，通过提高管理质效，实现增效降本。他提出，未来企业将立足于一体化
        服务优势，以产业细分领域为切入点，实现产业数字化转型的同时，构建产业数字化供应链平台，实现从管理赋能到市场 化乃至资本的转型。
      </div>


    </div>
    <div class="content" v-if="$route.query.id==1">
      <div class="content1">苏州市工业互联网创新应用峰会暨苏州市工业互联网产业联盟年会隆重举办</div>
      <div class="content2">2021年3月30日</div>
      <div class="content3">
        近年来，以工业互联网为代表的新一代信息技术创新应用正引领新一轮科技革命和产业变革。为进一步贯彻落实市委、市
        政府相关工作部署，加快推进苏州市工业互联网创新发展，完善工业互联网产业生态体系建设，在市工信局指导下，
        <span style="color:darkred;font-weight: bold">今天 （3月30日）下午，苏州市工业互联网产业联盟在高新区清山会议
                    中心隆重召开苏州市工业互联网创新应用峰会暨苏州市 工业互联网产业联盟年会。
            </span>
      </div>

      <div class="content4">
        <img src="../../public/statics/img/newlist/3.30/01.png" alt="">
      </div>
      <div class="content3">
        本次大会旨在进一步推动数字化赋能，全力打响“工业互联网看苏州”品牌，加速智能化改造和数字化转型，完善“工业互联网看苏州”发展生态，加快苏州工业互联网发展进度。
      </div>


      <div class="content3">
        江苏省工业和信息化厅两化融合处一级调研员贡苏康，苏州市工业和信息化局副局长贾长城，苏州市工业互联网产业联盟常务副会长徐泰伟，首席顾问张道洲，秘书长李娜等领导，联盟各会员单位代表，办事处、专委会代表，工业互联网领域相关专家和业界同仁以及媒体机构等近400人出席了本次大会。
      </div>

      <div class="content3">
        苏州市工业和信息化局副局长贾长城在致辞中对联盟新一年工作提出三点要求：一是有的放矢，同频共振，强化政府支撑“新品牌”；二是创新为先，聚势借力，推动行业合作“新格局”；三是持续发力，逐点及面，优化会员服务“新模式”。
      </div>
      <div class="content3">
        贾长城表示，2021年是“苏州制造”品牌建设和我市工业互联网创新发展三年行动计划的开局之年，希望各会员单位都能利用好苏州市工业互联网产业联盟这一宝贵的平台资源，加快推进“新两化”工作，不断将“工业互联网看苏州”品牌擦亮成为“苏州制造”品牌的闪光点，为我市争创国家级“5G+工业互联网”融合应用示范区凝心聚力。
      </div>
      <div class="content3">
        在随后的会议中分别进行了工作汇报、政策解读，并进行了“新两化”在路上系列活动——“数字化转型”区县行启动仪式。
        <span style="font-weight: bold"> 由省工信厅两化融合处一级调研员贡苏康，市工信局副局长贾长城，联盟常务副会长徐泰伟一同启动。</span>
      </div>

    </div>
    <div class="content" v-if="$route.query.id==2">
      <div class="content1">利用大数据提升宏观经济治理能力</div>
      <div class="content2">2021年3月9日</div>
      <div class="content4">
        <img src="../../public/statics/img/newlist/3.9/01.png" alt="">
      </div>
      <div class="content3">
        宏观经济治理是以促进经济高质量发展为目的，以发挥市场在资源配置中的决定性作用和更好发挥作用为原则，均衡使用财政和货币政策，完善科技、产业、就业等各方面制度建设，最终服务于国家治理体系和治理能力现代化大局的一项重大发展任务。宏观经济治理的起点是精准把握经济运行的总体态势。《中央国务院关于新时代加快完善社会主义市场经济体制的意见》对“充分利用大数据、人工智能等新技术”、“强化经济监测预测预警能力”作了明确要求。大数据以其丰富的信息价值，为宏观经济监测与预测开拓了新的思，成为提升宏观经济治理能力的重要保障。
      </div>
      <div class="content3">
        依据大数据了解宏观经济系统运行的总体态势。一是用于经济增长速度、货币供应量、物价水平、对外贸易额等总量性指标的变化，精确显示经济总水平的发展状况。二是用于三大产业结构、消费投资和贸易占比、农村和城镇经济比重、地区经济发展不平衡系数、居民收入差距等结构性指标的变化，辅助研判宏观经济系统的机制演化。三是用于构造经济景气指数，经济涨落的周期性变化、信用和货币流通规模的阶段性收缩或扩张等情况，帮助中央与各级地方、央行制定合理的财政与货币政策。
      </div>
      <div class="content3">
        依据大数据诊断宏观经济政策的实施效果。协调运用多种宏观经济政策工具是我国宏观经济治理的一个重要特征。大数据凭借对宏观经济运行的实时，在事前政策模拟与政策仿真、事中政策落地监管和事后政策效果评估中，密切宏观经济政策的落地情况和实施效果，持续反馈有助于政策选择和政策调整的高质量信息，确保宏观经济运行在预期轨道上。
      </div>
      <div class="content3">
        依据大数据监测外部经济的发展变化。在经济高质量发展阶段，我国对外的大门越开越大。从“引进来”角度看，中国经济与世界经济早已融为一体，我国连续多年稳居世界第二大外资流入国。从“走出去”角度看，中国企业海外投资规模持续扩大，我国在全球经济治理体系变革中的影响力和参与度不断提升。在中国经济内外两个市场的深度融合过程中，大数据发挥了助推器和重要媒介作用，也随之富藏了大量的信息价值。利用大数据强化对外部经济的监测，能够帮助我国在不断变化的国际中更有效地捕捉机遇和规避风险，更好地参与国际竞争与合作。
        随着互联网、物联网在生产生活中的渗透率不断攀升，社会经济活动的方方面面已充分在由大数据汇成的信息海洋中。大数据如同一台宏观经济“显微镜”，能够生动显示出宏观经济现象的微观联系，为宏观经济预测提供了全新的思并大大提升了预测的实际效果。高质量的预测能够为宏观经济治理提供先导性的，助力宏观经济治理由经验型转向数据型、由定性目标转向定量目标、由粗放调控转向精准调控，提升各项宏观经济政策的针对性、准确性和有效性。
      </div>
      <div class="content3">
        充分利用“搜索大数据”预测宏观经济在需求侧的结构性变化。我国拥有全世界规模最大的互联网用户群体，而搜索信息是中国网民使用互联网的重要目的之一。海量的网民搜索行为留下了可观的搜索大数据资源，能够及时反映重大的民生关切，继而用于预测宏观经济在需求侧的结构性变化。比如，当消费市场上的商品价格出现集体上涨时，大量网民将通过搜索引擎了解市场价格变化的原因和未来趋势，这些数据为了解预期和精准预测通货膨胀率提供了重要的信息来源，也为及时出台政策平抑物价，利用宣传工具稳定市场预期，创造了宝贵的时间窗口期。
        充分利用“舆情大数据”预测宏观经济在供给侧的结构性变化。企业是宏观经济系统的细胞，一方面受政策公开、市场情绪和公共影响，另一方面又通过信息披露、新闻发布等渠道影响整个市场的走势。企业信息平台、自和社交网络的日渐成熟，加速了整个市场的信息发布与信息流动。这些由文本、图像和语音等结构化或非结构化数据共同组成的舆情大数据资源，生动地出宏观经济在供给侧的微观变化。以金融市场为例，利用大数据技术挖掘企业客户在各类信息平台上的痕迹，商业银行等金融机构能够对货币市场、债券市场、股票市场和外汇市场等各类金融市场的行情变化展开预测，这为央行调控货币总量与信贷规模提供了重要的方法参考。
      </div>
      <div class="content3">
        充分利用“空间大数据”预测双循环新发展格局的演化态势。习总指出，中国经济是一片大海，而不是一个小池塘。在历经风云变幻后，中国经济已育新机、开新局，必须加快构建完整的内需体系，逐步形成以国内大循环为主体、国内国际双循环相互促进的新发展格局。在此背景下，空间大数据成为观测“这片大海”潮起潮退的瞭望台。空间大数据是以人造卫星服务、个人设备定位装置、固定摄像头等多类型物联网设施为硬件基础，汇集人流、物流、信息流等多重信息的巨型数据集，具有反映双循环新发展格局演化特征的天然基础。比如，社交网络是重要的信息分享渠道，经济繁荣地区无一不具备发达的社交网络，以空间大数据为基础，社交网络的密度变化能够准确反映区域经济活动的枯荣，为地方精准施策提供依据。
      </div>
      <div class="content3">
        大数据是信息化时代的馈赠，能够进一步人类社会经济活动的复杂规律，是提高宏观经济治理效能的有力支撑。将大数据进一步为宏观经济治理红利，需要加快大数据高效安全开发，破解目前存在的重大瓶颈。
      </div>
      <div class="content3">
        增加大数据在宏观经济治理中的“出境率”，根源在加快数据流通。目前，人类社会可直接利用的大数据资源仍然只是“冰山一角”，大量“数据孤岛”、“数据烟囱”的存在，导致大数据资源高度分散、流动性差、协同处理效率低。地方应从政务大数据互联互通做起，加强顶层设计与统筹协调，利益本位主义思维，切实做到“让群众少跑腿、让数据多跑”。必须加快电信、金融、公共服务等重点领域的数据流通，大力推动数据标准体系建设，在关乎国家发展、城市建设、百姓生活等国计民生方面，率先实现数据集成和数据共享。应鼓励业界建立行业规范，逐步实现产业大数据、商务大数据融合发展。只有充分流动、分享的大数据资源，才能够提升大数据在宏观经济治理中的作用。
      </div>
      <div class="content3">
        提升大数据在宏观经济治理中的“正确率”，关键在加强数据挖掘。大数据是包藏大量未知价值的数据集，必须树立大数据思维，提升运用人工智能、机器学习、知识发现等大数据处理技术的能力，尊重大数据分析的客观性、准确性，重视大数据与传统统计数据在相互检验方面的作用，戒除拍脑袋、主观主义决策，在充分发挥大数据监测与预测宏观经济走势的基础上，持续提升宏观经济政策的精准性、科学性和预见性，稳步增强宏观经济治理的效能，为建设数字化与智慧型提供助力。
      </div>
      <div class="content3">
        确保大数据在宏观经济治理中的“合格率”，底线是保障数据安全。大数据的、集成与运用可能涉及、商业机密和个人隐私，必须在立法层面完善相关规则，要进一步权衡数据与权益、信息安全与社会需求之间的关系，完善数据安全等级和关键信息制度，强化数据安全防护体系，明确可、可共享、可转用的数据范围，规范数据资源的开发利用。此外，应当《民》对个利的，将个人数据的案件纳入公诉范畴。只有满足安全性要求，宏观经济治理才具有服务国家与社会的可能性和基础条件。
      </div>
    </div>
    <div class="content" v-if="$route.query.id==3">
      <div class="content1">智能物流”大连工博会上成热点</div>
      <div class="content2">2021年5月15日</div>
      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/5.15/01.png" alt="">
      </div>
      <div class="content3">
        近日，在大连自贸区国际会展中心举行的第23届大连国际工业博览会上，工业数字化管理系统及人工智能等新技术成为亮点，遨博公司的协作机器人、极智嘉的智能物流机器人引起业界普遍关注。大连太和机电设备有限公司负责人告诉记者，大连工博会短短几天，中国华录、鞍钢集团等近百家企业到公司展台参观和咨询极智嘉的智能物流机器人产品，30多家企业已就合作进行初步接洽，某3C制造企业近日将签约引入极智嘉智能物流系统。
      </div>
      <div class="content3">
        极智嘉科技是一家引领全球智慧物流变革的智能机器人企业，为客户提供全品类物流机器人产品线和解决方案。其客户包括耐克、迪卡侬、沃尔玛、丰田、西门子等全球超300家知名企业。据全球市场研究机构Interact
        Analysis报告显示，极智嘉的全球AMR市场份额位居世界第一。2018年起，极智嘉科技进军东北市场，以其业界领先的智慧物流新产品新理念，助力东北企业实现物流智能化转型升级。
      </div>
      <div class="content3">
        大连太和机电设备有限公司是极智嘉在辽宁地区的合作伙伴，是一家集工程设计、系统集成、安装调试为一体的智能制造设备供应商和服务商。作为一家“土生土长”的本土企业，太和机电设备负责人对智能物流给企业带来的变化感触最深。他告诉记者，智能物流给东北老工业基地带来的不仅是先进的智能机器人新产品，还有企业经营管理的全新思维。以极智嘉的产品为例，其货架到人机器人有效节省人工劳动力50%~70%，拣选准确率不低于99.995%；货箱到人机器人相比人工仓，拣选效率提升2~3倍，仓储能力提高2.5倍；智能叉车采用自主研发的SLAM导航方案和AI视觉算法，具有强大的环境感知能力；智能仓方案为客户提供仓储自动化全流程柔性解决方案，实现机器人仓储应用一站式服务。据悉，目前外资企业和大型骨干企业对智能物流认可度较高，华晨宝马、北方图书出版社等已先后采用了极智嘉科技的产品，实际运行情况良好，未来还将继续加强合作。
      </div>
      <div class="content3">
        极智嘉科技有限公司相关负责人告诉记者，公司目前正在加大东北市场拓展力度，希望在大连打造更多的示范项目，进而辐射东北腹地，实实在在地助力东北老工业基地振兴。
      </div>
      <div class="content3">
        依据大数据监测外部经济的发展变化。在经济高质量发展阶段，我国对外的大门越开越大。从“引进来”角度看，中国经济与世界经济早已融为一体，我国连续多年稳居世界第二大外资流入国。从“走出去”角度看，中国企业海外投资规模持续扩大，我国在全球经济治理体系变革中的影响力和参与度不断提升。在中国经济内外两个市场的深度融合过程中，大数据发挥了助推器和重要媒介作用，也随之富藏了大量的信息价值。利用大数据强化对外部经济的监测，能够帮助我国在不断变化的国际中更有效地捕捉机遇和规避风险，更好地参与国际竞争与合作。
        随着互联网、物联网在生产生活中的渗透率不断攀升，社会经济活动的方方面面已充分在由大数据汇成的信息海洋中。大数据如同一台宏观经济“显微镜”，能够生动显示出宏观经济现象的微观联系，为宏观经济预测提供了全新的思并大大提升了预测的实际效果。高质量的预测能够为宏观经济治理提供先导性的，助力宏观经济治理由经验型转向数据型、由定性目标转向定量目标、由粗放调控转向精准调控，提升各项宏观经济政策的针对性、准确性和有效性。
      </div>
    </div>
    <div class="content" v-if="$route.query.id==4">
      <div class="content1">大物流时代来临，天津、武汉、西安、赣州、衡阳、襄阳等迎来风口</div>
      <div class="content2">2021年5月19日</div>
      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/5.19/01.png" alt="">
      </div>
      <div class="content3">
        2019年中国社会消费品零售总额5.97万亿美元，而美国为6.24万亿美元，中国人均4264美元，美国人均18909美元，美国人均消费是中国的4.43倍。
        到2035年中国人均收入预计将增长2.5倍，人均年消费达到10660美元，中国社会消费品零售总额将达到14.9万亿美元，是美国的2倍，成为人类迄今为止最大的单一市场，中国内循环经济将同“世界工厂”一样，成为人类最为庞大的经济系统！
      </div>
      <div class="content3">
        内循环本质上是由“制造”、“物流”和“消费”三大体系构成，中国目前的道路交通系统显然无法承载货运量翻倍的海量运输，交通物流体系的进化成为必然：
      </div>
      <div class="content3">
        1、主干道，尤其是高速公路会建设更多复线，形成更密集的高速公路网，县县通高速将基本实现；
      </div>
      <div class="content3">
        2、一些货物运输量比较大的线路，可能会实行客货分流机制，即载客车辆和载货车辆各走专用道路，以确保物流效率；
      </div>
      <div class="content3">
        3、北方将掀起内河航运建设高潮，河南、山东、河北将建设北方内河航运网络，承担大宗商品运输，给公路、铁路减负；
      </div>
      <div class="content3">
        4、交通科技和物流科技成为创新热点，新型货运方式和交通工具将会出现，比如地下真空管道运输、吊轨运输、输送带货运专线等；
      </div>
      <div class="content3">
        5、汽车全面进入电动和自动驾驶时代，没有了驾驶室和司机的汽车运力更大，成本更低；
      </div>
      <div class="content3">
        6、出现面积达上百平方公里的国家物流中心和30-50平方公里的区域物流中心；
      </div>
      <div class="content3">
        7、中国将成为智能物流和智能交通强国，并成为全球行业的引领者。
        基于内循环市场增长预期，我认为中国交通基建规模未来15年将会翻倍，高速公路里程达到35万公里，高铁达到6万公里，普通铁路达到18万公里，智能物流和智能交通投资达数万亿元，建成世界一流的智能交通物流网络，年创造增加值达3万亿美元以上。
      </div>
      <div class="content3">
        一、未来国家物流中枢<br/>
        北方中枢：天津；<br/>
        中部中枢：武汉、郑州；<br/>
        西北中枢：西安；<br/>
        东部中枢：上海、南京；<br/>
        西南中枢：重庆；<br/>
        南方中枢：广州；<br/>
        东北中枢：沈阳。
      </div>
      <div class="content3">
        二、未来区域物流中心<br/>
        北方：石家庄、保定、邯郸；<br/>
        中部：长沙、南昌、襄阳、南阳、岳阳；<br/>
        西北：兰州、乌鲁木齐、喀什；<br/>
        东部：宁波、济南、青岛、合肥、杭州、福州、厦门、泉州、潍坊、临沂、徐州、阜阳、淮安、扬州；<br/>
        西南：成都、贵阳、昆明、泸州；<br/>
        南方：深圳、惠州、湛江、赣州、南宁、衡阳；<br/>
        东北：长春、大连、哈尔滨、葫芦岛、锦州。
      </div>
      <div class="content3">
        三、重点机遇城市
      </div>
      <div class="content3">
        1、天津<br/>
        如果要在北方找一个铁路、公路、海运、仓储、区位、科技、制造、人口等八方面都非常完美的物流中心，那非天津莫属。天津是国内进入智能交通和智能物流领域比较早的城市，形成了一定技术积累，国家可以在天津设立一个智能交通物流创新实验室，探索未来智能化的交通物流。建议天津沿京沪高速建设一座南北绵延百里的物流产业带，作为北方物流集散中心，将周边制造的商品汇集到这里，然后通过高效、智能、低成本的物流系统，输送到全国各地。未来物流产业有望为天津每年创造1万亿元GDP！
      </div>
      <div class="content3">
        2、武汉<br/>
        武汉地理位置优越，是天然的交通物流枢纽，以武汉为中心，1000公里半径的圆，几乎可以囊括中国80%的经济和人口，而且武汉还有长江这条黄金航道，通过长江无数条支流，可以触达南方大部分地区。建议尽早推动浙赣粤大运河和汉湘桂大运河的建设，将南方水系联通成网。在武汉建设中国内河物流中心，并设立水上智能交通实验室，开发高速、自动驾驶智能物流船。
      </div>
      <div class="content3">
        3、西安<br/>
        西安是一带一路中枢，中欧班列最大集散中心，
        同时也是中国西北地区最大物流中心，所以西安物流中心既是内循环的支点，也是外循环的中枢之一，叠加内外双循环。中国未来应将智能交通系统向一带一路拓展，并以此为基础建设全球智能物流网，作为中国制造的核心竞争力！全球物流网未来或许会成为中国制造的护城河，将其它竞争者阻挡在外！
      </div>
      <div class="content3">
        4、赣州<br/>
        京九铁路、兴泉铁路、赣韶铁路、昌赣深高铁、渝长厦高铁、赣江、浙赣粤大运河，这些线路一旦全部建设完成，从赣州几乎可以通达南方任何城市，甚至直达山东、天津，未来赣州无疑将成为华南地区最重要的交通物流枢纽。有如此强大的物流加持，未来赣州经济如虎添翼！
      </div>
      <div class="content3">
        5、衡阳<br/>
        衡阳有非常好的交通基础，公路、铁路、水运都非常发达，具备年运输货物3亿吨的能力，现在只有7000万吨，物流潜力只发挥了四分之一。衡阳应把物流作为优先发展的产业，争取成为南方十大物流中心之一。衡阳应成为沿海产业转移的优先选择，以衡阳为基地发展制造业，物流将是非常大的优势。
      </div>
      <div class="content3">
        6、潍坊<br/>
        潍坊目前已经是山东物流中心，未来还有三大因素让潍坊升级成为北方最重要的物流中心之一：一是，小清河济南-潍坊段即将通航，潍坊内河航运将大大强化；二是，京沪二线即将开建，未来运力充足的情况下，国家将开展高铁物流；三是，渤海湾跨海隧道如果开建，潍坊将成为华东、华南、中部地区与东北物流的中心。交通物流升级后，潍坊有望迎来二次改革开放，跻身二线城市之列。
      </div>
      <div class="content3">
        7、临沂<br/>
        临沂虽然号称“物流之都”，但仅限于公路物流。然，可以预见，未来15年随着中国交通网络升级，临沂铁路枢纽将日渐成型，京沪二线、济临城际、临徐城际、临连城际，甚至商枣临日铁路都会陆续建成或进入议事日程，届时临沂不仅是国内重要物流中心，还将是亚欧贸易大通道重要起点。补齐铁路短板的临沂将从一座区域城市，上升为全国性城市，开启冲击二线之旅。
      </div>
      <div class="content3">
        8、淮安<br/>
        淮安曾经运河之都，现在由于北方运河断航，导致淮安地位大幅下降。未来河南、山东、河北运河网如果建成，淮安将成为南方与北方水运的中枢，恢复运河之都之名，属于淮安的时代就会到来，到时苏北中心城市之争将在淮安与徐州之间展开！
      </div>
      <div class="content3">
        9、襄阳<br/>
        从公路货运量来说，2019年襄阳达3.6亿吨，三线城市第一，虽然周转量比不上临沂，也可见襄阳物流实力不容小觑。襄阳还是全国重要铁路枢纽，郑万高铁、武西高铁、呼南高铁、浩吉铁路、汉丹铁路、焦柳铁路、襄渝铁路纵横交错，铁路枢纽地位三线城市第一。公路、铁路之外，襄阳还有汉江，可通过长江通达南方各省。可见，襄阳交通，得天独厚，物流中心已在掌中。襄阳本身工商业发达，未来再发挥出物流实力，经济前景可期！
      </div>
      <div class="content3">
        工业化、网络化、数字化之后，大物流时代即将到来，未来将是物流和消费为王的时代，谁能抓住这两大机遇，谁就能在新一轮经济进化中崛起！
      </div>
    </div>
    <div class="content" v-if="$route.query.id==5">
      <div class="content1">每年约有8000万吨蔬菜腐烂，蔬菜冷链物流需求巨大</div>
      <div class="content2">2021年7月29日</div>
      <div class="content3">
        近期在北京市场，<span class="boderclas">多种蔬菜都出现了价格上涨的情况</span>。以青椒为例，目前，价格每公斤6元以上，环比涨两成，同比涨幅在50%左右。数据显示，农业农村部监测的28种蔬菜全国平均批发价每公斤4.48元，环比跌3.7%。
      </div>
      <div class="content3">
        我国蔬菜加工全行业销售收入接近7500亿元。其中，规模以上企业数量为2300余家，合计销售收入为4000亿元以上，在全行业收入中的占比为53%。蔬菜是我国仅次于粮食的第二大种植农作物，年产量和人家消费量均处于较高水平。蔬菜是不耐放农产品，但由于得不到有效保存及利用，<span
          class="boderclas">我国每年约有8000万吨蔬菜腐烂</span>，造成巨大经济损失。因此提升冷链物流仓储水平，实现集约化农业生产，是我国蔬菜产业发展的趋势。
      </div>
      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/7.29/01.jpg" alt="">
      </div>

      <div class="content3">
        <span class="boderclas">农产品冷链</span>泛指水果、蔬菜、肉类等物品在生产、贮藏运输、销售，到消费前的各个环节中始终处于规定的低温环境下，以保证物品质量和性能的一项系统工程，主要包括冷冻加工、冷冻贮藏、冷藏运输及配送、冷冻销售四个方面。
      </div>
      <div class="content3">
        近年来，<span class="boderclas">农产品冷链物流规模快速发展</span>。从农产品冷链产品结构来看，主要分为水果、蔬菜、肉类和水产品四大类，2020年上述四大类冷链物流规模达到21370.4万吨，同比增长24.8%，其中水果、蔬菜的冷链需求较大，占比都超过30%。
      </div>
      <div class="content3">
        从冷链发货省份来看，农产品大省山东是冷链发货量最大的省份，货量占到12%，紧随其后的是广东10%，云南7%。而发货第一大城市则是上海，货量占比3%，2020年冷链top10热门路线中，上海就占据了6条。这六条线路中，除上海市内冷链运输货量同比呈下降趋势外，降低了32%，其余线路均上涨，且涨幅均超过50%。
      </div>
      <div class="content3">
        在电商零售不断发展的背景下，传统农产品冷链物流模式受到了一定的冲击，农产品采摘后经由冷链运输直接送到消费者手中，大大缩短了流通环节，电商直销冷链模式逐渐受到消费者的青睐。目前的农产品电商冷链流通模式得到了极大的发展。未来，中国农产品冷链物流行业还有较大的增长空间。
      </div>
      <div class="content1 boderclas">
        我国蔬菜加工行业现状
      </div>
      <div class="content3">
        我国地域辽阔，不同蔬菜在不同地区的供需结局差别较大，新鲜蔬菜的运输和贮藏较为困难，区域供需不平衡的状况亟待改善。蔬菜加工可以合理利用及分配蔬菜资源，有利于降低蔬菜损失率及改善区域供需格局，并提高农民收入，其行业规模持续扩大。
      </div>
      <div class="content3">
        2018年，我国蔬菜加工全行业销售收入接近7500亿元。其中，规模以上企业数量为2300余家，合计销售收入为4000亿元以上，在全行业收入中的占比为53%。我国蔬菜加工行业企业数量众多，大部分企业规模较小，市场集中度低。
        蔬菜加工产品主要包括生鲜蔬菜、腌制蔬菜、脱水蔬菜、速冻蔬菜、蔬菜汁、蔬菜罐头等类别。在加工技术及装备方面，我国蔬菜加工行业正在不断进步，已经形成了一批具有较强竞争力的企业，产业集聚地逐渐显现，如西北番茄酱加工基地、东南沿海干制、罐头、速冻、腌制蔬菜加工基地等，产业格局基本形成。
        我国蔬菜消费以生鲜为主，蔬菜加工行业起步较晚，与发达国家相比行业发展仍较落后。我国蔬菜加工所需的原料，其供应基地规模化发展不足，供应的蔬菜质量高低不一;蔬菜加工装备制造水平偏低，在关键技术领域缺乏自主知识产权;蔬菜加工的深度不够，产品品种较为单一，规模化、自动化水平较低，相关标准体系建设不完善。整体来看，我国蔬菜加工行业在技术和运营方面发展尚不成熟，国际竞争力较低。
      </div>
      <div class="content3">
        随着农业“走出去”和“一带一路”倡议的推进，中国在保持蔬菜及其加工制品对发达国家的出口占据优势的同时，还将增加对中亚、中东及非洲地区的贸易量，今后很长一段时间，中国在蔬菜及其加工制品出口上都将面临出口国及沿线国家政治不稳定、经济发展乏力及发达国家贸易战的挑战。
      </div>


    </div>
    <div class="content" v-if="$route.query.id==6">
      <div class="content1">城市与物流：反哺与被反哺</div>
      <div class="content2">2021年8月6日</div>

      <div class="content3">
        “城市物流，顾名思义是以城市为主体，围绕城市经济发展需要而产生的物流活动。”笔者认为，作为城市经济的重要组成部分，城市物流主要着重服务于“两个稳定”，即城市居民消费稳定和城市产业链稳定。
      </div>
      <div class="content3">
        <span class="boderclas">城市物流推动城市产业新发展</span>
      </div>
      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/8.6/01.png" alt="">
      </div>

      <div class="content3">
        在经济高速发展的背景下，城市物流已经成为推动经济发展的重要引擎，在经济发展的过程中起着不可或缺的作用。
      </div>
      <div class="content3">
         城市物流是建立现代化经济体系的助推器。建设现代化经济体系是推动产业优化升级、加快形成新动能、实现经济高质量发展的必然要求。保持产业链的稳定是现代经济体系建设的目的之一，有效提升产业链的韧性，保持国家经济安全;构建层次分明、功能齐全、标准高效的城市物流体系，实现生产要素、经济资源的有机整合和优化配置，是促进城市产业链稳定、实现产业全链条发展的最重要保障。
      </div>
      <div class="content3">
         城市物流是实现经济高质量发展的压舱石。产业是城市经济发展的核心，建立高效专业的城市物流体系不仅可以使产业链之间的资源要素实现有机整合，更能够有效降低产业供应链成本，补齐产业链供应链短板，形成推动产业发展的核心竞争力，从而带动城市经济创新发展。
      </div>
      <div class="content3">
        城市物流是推动新旧动能转换的定盘星。随着大数据、互联网、人工智能等科技的发展，城市物流以新技术、新模式、新业态、新产业等“四新”业态为代表的跨界融合型产业正推动着城市供应链体系发生深刻变革，从而带动产业管理、技术、人才的创新，助推产业的动能转换。
      </div>
      <div class="content3">
        城市物流在经济高速发展之中不断转型升级，进一步推动着城市产业新的发展。
      </div>


      <div class="content3">
        <span class="boderclas">诸多痛点制约城市物流高速发展</span>
      </div>
      <div class="content3">
        虽然当前城市物流在新发展格局的背景下不断转型升级，但我国城市物流的发展尚未到达成熟阶段。
      </div>
      <div class="content3">
        从外部因素来看，制约城市物流发展的外部因素主要有以下3点。一是网点布局乱，城市物流配套设施紧缺、缺乏科学统一的城市
        物流规划等问题，制约了物流、快递企业科学合理布局物流网点，因此也影响了城市物流效率、增加了企业运营成本;二是交通压力
        大，城市内部的运输工具缺乏统一的组织管理，存在重复运输、单程运输等问题，货车进城区域和时间管制等问题都容易造成城市交
        通拥堵;三是产业融合度低，物流企业专业化服务能力和水平不高，不能有效适应产业发展需求，导致融合发展还存在融合层次不够
        高、范围不够广、程度不够深等问题。
      </div>
      <div class="content3">
        从内部因素来看，制约城市物流发展的因素主要来自物流企业自身。一是供给能力弱，物流企业管理水平不高而导致物流服务深度、
        广度不够;二是人才适配弱，物流企业对人才重视程度和引进、培养力度不够，物流专业人才匮乏是制约企业智慧化转型升级的重
        要因素;三是资源聚合弱，多数物流企业缺乏资源整合能力，因此在产业链供应链中处于弱势地位，缺乏对物流活动的主导性。
      </div>
      <div class="content3">
        基于此，应着力解决制约城市物流高速发展的多重因素。首先，国家出台相关政策，合理布局城市交通等方面的运输流程;其次，
        企业应加强自身实力，增强企业之间的合作，培养专业物流人才，共同提升物流运转效率。多方合力方能有效推动城市物流转型升级，促进城市经济快速发展。
      </div>


      <div class="content3">
        <span class="boderclas">城市物流发展新突破</span>
      </div>
      <div class="content3">
         强化顶层设计，规划引领。国家层面发挥国家物流枢纽、国家骨干冷链物流基地等在物流运行体系中的骨干作用，加快与区域经
        济和相关产业的互动融合;地方层面科学制定物流产业规划，合理布局物流基础设施，打造内外衔接、绿色高效的城市物流体系。
      </div>
      <div class="content3">
          强化政策支持，导向引领。完善体制机制，加强政策引导，出台支持城市物流发展的政策措施，培育一批资源整合强、创
        新能力强、服务质量高的现代物流企业。
      </div>
      <div class="content3">
         强化基础设施，要素引领。根据城市产业结构特点，合理布局商贸型、加工型、仓储型、配送型、应急型等物流中心，形成畅通
        完整的城市物流基础设施网络。鼓励物流企业提高信息技术水平、应用自动化智能装备，提升物流运行效率，实现企业智能化改造升级。
      </div>
      <div class="content3">
         强化融合能力，服务引领。培育、引进、整合一批协同能力强、服务水平高的现代物流企业，促进物流业产业联动融合发展。深入
        推进放管服改革，对物流业融合发展新业态、新模式实施包容审慎监管，为融合创新发展创造良好条件。
      </div>
      <div class="content3">
        强化人才支撑，智力引领。依托高等院校、科研院所、行业协会等机构，培养、培训一批信息整合、路径优化、产业融合、供应链
        协同等方面的专业化人才，推动城市物流高质量发展。
      </div>
      <div class="content3">
         中国城市经济增长与发展空间广阔，在新时代背景下，在新机遇的推动下，中国城市物流业必将迎来新的发展，带动城市经济再登新台阶。
      </div>


    </div>
    <div class="content" v-if="$route.query.id==7">
      <div class="content1">网络货运合规化 不应该那么难</div>
      <div class="content2">2021年8月13日</div>
      <div class="content3">
        互联网红利下的网络货运平台
      </div>
      <div class="content3">
         物流是贯穿一二三产业，衔接生产与消费的重要环节之一，在国民经济体系中地位越来越不可忽视，无论是海、陆，或是空，都充斥着物流业的身影。作为现代流通体系重要的组成部分，其作用不言而喻。
      </div>
      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/8.13/01.png" alt="">
      </div>
      <div class="content3">
          物畅其流才能货通天下，尤其是在互联网时代的高速发展下，“懒人经济”效应被不断扩大。从线下零售到电商再到“购全球”;从一周达到三日达再到即时配送。毫无疑问，物流业已经逐渐改变了人们的生活方式，也无一例外的正在颠覆着对传统行业的认知。
      </div>
      <div class="content3">
         受益于互联网经济的迅速崛起，当前数字化发展形势一片大好，近几年不少物流企业迎着风口踏浪前来，开始对互联网模式下的物流行业进行全新摸索。其中，网络货运平台便成为资本竞相追逐的“风口”之一。
      </div>
      <div class="content3">
        网络货运平台的出现具有简单快捷性，通过互联网技术将散乱的资源信息连接在一起，让物流信息在短时间内实现互通共享，加快了对散乱物流信息的收集、管理以及应用，提升了整体供应链效率。
      </div>

      <div class="content3">
        <span class="boderclas">行业乱象 制约发展步伐</span>
      </div>
      <div class="content3">
         行业的进步往往会伴随一些问题的出现，网络货运同样也不例外，恶性竞争、价格战、平台收费不规范等无疑让从业者对其“又爱又恨”。一方面是这类平台整合了大量的用车信息，让更多货源出现在大家面前，信息匹配率更高，司机能够轻松接单。另一方面是货运APP的盛行让运价越“杀”越狠，盈利空间明显被压缩，并且很多时候都是平台一方说了算，尤其是关乎利益时，卡车司机也只能默默忍让。
      </div>
      <div class="content3">
        《2021年货车司机从业状况调查报告》显示，在被调查的6000名货车司机中，超过一半的司机都是通过网络货运平台寻找货源，有78.8%的司机，认为部分网络货运平台存在托运人故意压低运价和司机低于成本竞价的不正当竞争现象。
      </div>
      <div class="content3">
        尽管国家三令五申要坚决查处各种乱收费、乱罚款、搞变相涨价等加重企业、从业者负担的行为，但行业乱象依然屡见不鲜。个别不规范的网络货运经营者更是钻政策和监管的空子，不仅以各种名目多收钱、乱收钱，坑骗上游货主、下游货车司机，而且给主管部门上报虚假单据记录。
      </div>
      <div class="content3">
        某网络货运平台相关负责人表示，近年来国家整治网络货运效果已经十分显著，但一些乱象的确还是时有发生。平台抽成比例高、分配机制不公开透明、随意调整收费规则、上涨会员费等问题依然侵蚀着从业者的利益。若想彻底解决此类问题，不仅是国家单方面的事情，更重要的是要如何定义网络货运平台的经营模式，形成标准化、透明化的健全机制，真正的做到各方利益平衡。只有各方在利益不受损的情况下，行业才能走向正轨。
      </div>


      <div class="content3">
        <span class="boderclas">新政频出 企业尝试不断</span>
      </div>
      <div class="content3">
        针对平台侵害从业人员权益等不合规行为，近期主管部门对网络货运平台监管也在逐步加强。2021年4月22日，交通部提出要着力改善货车司机从业环境，切实提高行政执法规范化水平，完善道路运输车辆动态监控制度。5月14日，由交通运输部、中央网信办、国家发展改革委、工业和信息化部、公安部等8家成员单位对10家交通运输平台进行约谈，其中就不乏部分网络货运平台，约谈明确要求各平台要合理确定抽成比例和信息服务费水平;要主动降低抽成比例，保障驾驶员劳动报酬;要改善司机经营环境，保障从业人员就业、劳动安全、社会保险、职业培训等基本权益。
      </div>
      <div class="content3">
        种种迹象表明，针对网络货运平台存在的收费不规范等问题，国家已经开始出手整顿，而现在相关部门的频繁发声也是在给企业自我整改的缓冲时间。
      </div>
      <div class="content3">
         针对政策的不断出台，有专家建议应尽快修订相关法规，结合《电子商务法》的内容，引导撮合交易型平台承担承运责任，或者明确撮合交易平台的监管主体，进行分类施策。规范合同订立与履行机制，完善定价机制和争议解决机制，搭建运费保障制度，规范平台收费和信息发布行为。同时，平台企业应以业务真实性为核心，采取多种有效的针对性措施保证数据真实性，实现每笔业务的业务流、信息流、资金流、票据流、货物轨迹流的“五流合一”。
      </div>
      <div class="content3">
        事实上，正如专家所建议，也有不少企业在此方面做出了有益尝试。新华社旗下中国经济信息社近日发布的《网络货运平台发展调研报告(2020)》对网络货运平台现状做了深度调研，报告中指出，中储智运综合运用多种技术，在物流运力交易共享平台开展业务的基础上，打造数字化物流管理平台，通过“智运罗盘”
        “智运千里眼”等核心技术，将返程时间、返程线路最契合的车和货进行配对交易，对物流业务进行“五流合一”的高效运作和管理。同时，该公司的的每一单业务都坚持平台内交易，基于线上技术与线下服务的深度融合，全程介入货主与司机的货运业务，构建了“发布-匹配-议价/抢单-合同-装货-运输-卸货-回单确认-结算-开票”的完整运力交易数据链，在源头上保证了业务的真实性。业务闭环不仅确保了业务真实性，而且也承担了运输保障责任。
      </div>
      <div class="content3">
        报告中还提到，“G7利用物联网设备，通过获取车辆、道路、货物、交易等实时数据，深度连接重型卡车，并提供一体化网络货运服务，推动物流运输与结算的全程数字化”。
      </div>
      <div class="content3">
         “国家层面介入的效果显而易见，不少平台的信息越来越透明、收费也愈发规范，至少从我们从业者来说，确实要比之前好干一些”。某平台货车司机说道，“平台之间的竞争必然会是打压价格，这最终反应到的不是消费者身上而是我们从业者的身上。我们不仅要面对同行的压价竞争，同时还要对平台高抽成的行为忍气吞声。”该货车司机还表示现在平台接单已经成为了主要找货渠道，绝大部分运输从业者几乎都离不开网络货运平台，如果平台消失，单靠信息部、配货中心的话，在互联网时代，如今的从业者们将会很难生存。因此，平台的存在十分必要，国家层面的整改更是不可或缺。而现在，在国家、企业“动真格”的改革推动下，不规范收费的情况已明显好转。
      </div>
      <div class="content3">
        不难看出，随着相关政策的逐步出台，平台管理模式不规范、行业标准不统一、平台商业模式单一等问题正在向更标准化的模式完善，广大从业者的利益也在部分平台对政策的落实下得到更好保障。这也说明了要真正维护好从业者的利益，有效解决行业乱象问题，不仅是国家的事情，同样也是平台义不容辞的责任。
      </div>


      <div class="content3">
        <span class="boderclas">阵痛更利于长期发展</span>
      </div>
      <div class="content3">
         然而，不可否认的一点是，行业的改革也会带来相应的阵痛，更是会直接关系到平台一时的利益。毕竟要做到完全合规，将已经吃到的“肉”吐出一部分也是十分必要的。但从长期发展来看，阵痛虽然会在短时间内让各平台“割肉”，不过却是对行业发展的有利推手。
      </div>
      <div class="content3">
        因为网络货运作为一种先进的生产力已经逐渐被社会、被市场所接受和适应，市场的交易模式也不可能再倒退到从前。无论是货主、物流公司还是货车司机都已经接纳和习惯了这种更为便捷的交易模式，平台只要在定价机制和收费模式上合理公平能兼顾到以上几方的权益，货运平台依然会有很强的生存和盈利能力。
      </div>
      <div class="content3">
         回归本质来看，货车司机是网络货运平台的根本，双方协同发展，共生共存。平台收取服务费是为了让司机为货源信息买单，其实并无可厚非。但抽取运费，收费不规范，限制接单，设置VIP、甚至VVIP超级特权等，却让这原本的“信息费”变了味。与之而来的也必将是平台之间、司机之间的恶性竞争。
      </div>
      <div class="content3">
        随着行业逐步走向正轨，网络货运的透明化、合规化将是社会发展的必然趋势。而“压价”“不公平”“克扣”等字眼也会在政策和平台的规范下成为过去式。
      </div>
      <div class="content3">
         网络货运平台的出现是为了更好的服务于货车司机和货主，而并非成为敛财、引起恶性竞争的工具。如今，随着政策的频发，整改只是迟早的事情。希望网络货运平台能够秉承初心，帮助车主和货主更好完成车货匹配，通过提升服务质量、优化价格，营造出一个公平竞争的市场环境，为我国从物流大国到物流强国做出自己的贡献。
      </div>


    </div>
    <div class="content" v-if="$route.query.id==8">
      <div class="content1">商务部等9部门：培育一批有品牌影响力和国际竞争力的商贸物流企业</div>
      <div class="content2">2021年8月20日</div>
      <div class="content3">
        日前，商务部等9部门印发《商贸物流高质量发展专项行动计划(2021-2025年)》，到2025年，初步建立畅通高效、协同共享、标准规范、智能绿色、融合开放的现代商贸物流体系，培育一批有品牌影响力和国际竞争力的商贸物流企业，商贸物流标准化、数字化、智能化、绿色化水平显著提高，商贸物流网络更加健全，区域物流一体化加快推进，新模式新业态加快发展，商贸物流服务质量和效率进一步提升，商贸服务业和国际贸易物流成本进一步下降。
      </div>

      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/8.20/01.jpg" alt="">
      </div>
      <div class="content3">
        <span class="boderclas">原文如下：</span>
      </div>
      <div class="content3">
         为深入贯彻党的十九届五中全会精神，落实中央财经委员会第八次会议决策部署，健全现代流通体系，促进商贸物流提质降本增效，服务构建新发展格局，近日，商务部等9部门联合印发《商贸物流高质量发展专项行动计划(2021-2025年)》(商流通函〔2021〕397号，以下简称《计划》)，在全国范围内部署实施专项行动。
         
      </div>
      <div class="content3">
        《计划》提出，要以习近平新时代中国特色社会主义思想为指导，坚持市场主导、政府引导，坚持创新驱动、转型升级，坚持因地制宜、有序推进，着力提升商贸物流网络化、协同化、标准化、数字化、智能化、绿色化和全球化水平。到2025年，初步建立畅通高效、协同共享、标准规范、智能绿色、融合开放的现代商贸物流体系，为形成强大国内市场、构建新发展格局提供有力支撑。
      </div>
      <div class="content3">
        《计划》坚持问题导向、目标导向，针对我国商贸物流领域的短板和不足，提出了优化商贸物流网络布局、建设城乡高效配送体系、促进区域商贸物流一体化、提升商贸物流标准化水平、发展商贸物流新业态新模式、加快推进冷链物流发展、培育商贸物流骨干企业等12项重点任务和构建良好营商环境、加大政策支持力度、完善重点企业联系制度、发挥行业组织作用、加强商贸物流行业统计等5方面的保障措施。
      </div>
      <div class="content3">
        下一步，商务部将会同有关部门指导各地根据实际情况制定具体工作方案，确定重点任务和落实举措，明确工作目标，建立工作台账，扎实推进专项行动，确保各项任务措施落地落实。  
      </div>
    </div>
    <div class="content" v-if="$route.query.id==9">
      <div class="content1">什么是公路货运?公路货运的特点和作用</div>
      <div class="content2">2021年8月27日</div>
      <div class="content3">
        公路货物运输(Road
        Transportation)是现代运输主要方式之一，同时，也是构成陆上货物运输的两个基本运输方式之一。它在整个运输领域中占有重要的地位，并发挥着愈来愈重要的作用。公路货物运输由公路货物运输和汽车货物运输组成
      </div>

      <div class="content4">
        <img class="content2-3" src="../../public/statics/img/newlist/8.27/01.jpg" alt="">
      </div>
      <div class="content3">
        一、公路运输是一种机动灵活、简捷方便的运输方式，在短途货物集散运转上，它比铁路、航空运输具有更大的优越性，尤其在实现“门到门”的运输中，其重要性更为显著。尽管其他各种运输方式各有特点和优势，但或多或少都要依赖公路运输来完成最终两端的运输任务。例如铁路车站、水运港口码头和航空机场的货物集疏运输都离不开公路运输。
      </div>
      <div class="content3">
        二、 但公路运输也具有一定的局限性，如：载重量小，不适宜装载重件、大件货物、不适宜走长途运输;车辆运行中震动较大，易造成货损货差事故，同时，运输成本费用较水运和铁路为高哦。
      </div>
      <div class="content3">
        公路货运是货物运输里面最灵活的方式。货运代理商可以根据自身需求选择是否需要公路货运这种方式。一个准确的运输方式是整个运输活动成功的关键。一定要在出发前选择最适合的货运方式。
      </div>
    </div>

    <div class="recommend-cntr">
      <p class="header-title">热点文章</p>
      <hr/>
      <div class="article-title-cntr"
           v-for="(item, index) of articleTitle"
           :key="item.id"
           @click="toOtherArticle(item.id)"
      >
        <p class="index"
           :class="{top3_index: index < 3}"
           v-if="index < 9"
        >
          {{ index + 1 }}
        </p>
        <p class="index"
           :class="{top3_index: index < 3}"
           v-else
           style="margin-left: -5px; margin-right: 5px; margin-bottom: 100px;"
        >
          {{ index + 1 }}
        </p>
        <p class="article-title">{{ item.title }}</p>
      </div>
    </div>
  </div>

</template>

<script>
import top_mobile from "../components/top_mobile";
import news from '../../public/statics/newsdata'

export default {
  name: "newviewsdetails_mobile",
  data() {
    return {
      topshow: true,
      loading: true,
      articleTitle: []
    }
  },
  components: {
    top_mobile
  },
  mounted() {
    this.detaildata = news.newslist[this.$route.query.id];
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScrollx, true)
    setTimeout(() => {
      this.loading = false;
    }, 500)

    this.get_article_list()
  },
  methods: {
    handleScrollx() {
      if (window.pageYOffset > 0) {
        this.topshow = false;
      } else {
        this.topshow = true;
      }
      ;
    },
    goback() {
      this.$router.go(-1);
    },

    get_article_list() {
      this.articleTitle = []
      let counter = 0
      for (let item of news.newslist) {
        this.articleTitle.push({title: item.title, id: item.id})
        counter++
        if (counter == 10) {
          break;
        }
      }
    },

    toOtherArticle(id) {
      if (id > 9) {
        let url = news.newslist[news.newslist.length - id - 1].url
        this.$router.push({
          path: '/news_view_mobile',
          query: {
            url
          }
        })

      } else if (id >= 0) {
        this.$router.push({
          path: '/newviewsdetails_mobile',
          query: {
            id,
          }
        })
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    }
  },
}
</script>

<style scoped lang='scss'>
.newsdmbox {
  .title {
    width: calc(100% - 2rem);
    box-sizing: border-box;
    height: 45px;
    text-align: left;
    line-height: 45px;
    font-size: 16px;
    color: #444444;
    margin: 0.5rem 1rem;
    border-bottom: 1px solid #E5E5E5;
  }

  .content {
    padding: 1rem;
    box-sizing: border-box;
    font-family: "PingFang SC";
    text-align: left;

    .content1 {
      font-size: 16px;
      color: #333333;

    }

    .content2 {
      color: #B6B5B5;
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 10px;

    }

    .content3 {
      color: #999999;
      font-size: 14px;
      margin: 20px 0 10px;

      .boderclas {
        font-weight: bold;
        color: #666;
      }
    }

    .content4 {
      width: 100%;
      height: auto;

      img {
        width: 100%;
      }
    }

    .content2-4 {
      margin-top: 0.5rem;
      background: #fff2e2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-family: "PingFang SC";
      letter-spacing: 2px;
      padding-bottom: 0.1rem;

      .content2-4-1 {
        color: #fff;
        padding: 0 10px;
        background: #974806;
        font-size: 16px;
        height: 30px;
        line-height: 30px;
      }

      .content2-4-2 {
        color: #666666;
        font-size: 14px;
        margin-top: 0.3rem;
      }

      .content2-4-3 {
        color: #974806;
        font-size: 14px;
        margin-top: 0.3rem;
      }
    }
  }

  .recommend-cntr {
    width: 80vw;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    .header-title {
      text-align: left;
      font-size: 20px;
      font-weight: bold;
      margin: 0;
      border-bottom: 2px solid DimGray;
    }

    .header-title:before {
      content: '|';
      margin-right: 10px;
      font-size: 20px;
      font-weight: bold;
      color: red;
    }

    .article-title-cntr {
      display: flex;
      text-align: left;
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;

      .index {
        width: 25px;
        font-size: 20px;
        font-weight: bold;
      }

      .top3_index {
        color: red;
        font-size: 22px;
      }

      .article-title {
        width: calc(100% - 25px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .article-title:hover {
        color: dodgerblue;
      }
    }
  }
}
</style>
